import { HyperDropToast } from './components/HyperDropToast';

(function (Drupal) {
  Drupal.behaviors.hyperdropToast = {
    attach(context: HTMLElement) {
      const container = context.querySelector('[data-toast-container]');
      if (!container) return;

      const toast = new HyperDropToast({ elements: { container } });

      container.querySelectorAll<HTMLElement>('.toast-proxy').forEach(el => {
        let type = el.dataset.toastType || 'info';

        type =
          type === 'status' ? 'success' :
            type === 'error' ? 'error' :
              type === 'warning' ? 'warning' :
                'info';

        const message = el.dataset.toastMessage || '';
        toast.show(type, message, 20000, true);

        el.remove(); // cleanup
      });
    },
  };
})(Drupal as any);
